import { useLocalStorage } from '@mantine/hooks'

export interface UserGuide {
	DRAFT_RECOVER_TOOLTIP: boolean
}
export default function useUserGuide(key: keyof UserGuide) {
	const [value, set, remove] = useLocalStorage<UserGuide[typeof key]>({
		key,
		defaultValue: false,
		getInitialValueInEffect: false,
		serialize: (value) => value.toString(),
		deserialize: (value) => value === 'true',
	})

	return [
		value,
		() => {
			set(true)
		},
		remove,
	] as const
}
